module.exports = __webpack_public_path__ + "img/ppt-thumbnail.8c7dc3df.png";